import styled from 'styled-components';
import { black } from '../../colors';
import { TabsTheme } from '..';
import { TabTheme } from '../tab';
export var TabsThemeEx = Object.assign({}, TabsTheme, {
  Main: styled(TabsTheme.Main).withConfig({
    displayName: "styles__Main",
    componentId: "oodkzt-0"
  })(["width:100%;overflow-x:scroll;display:flex;flex-direction:column;align-items:flex-start;"]),
  List: styled(TabsTheme.List).withConfig({
    displayName: "styles__List",
    componentId: "oodkzt-1"
  })(["max-width:100%;border:unset;padding:0;border-radius:unset;"])
});
export var TabThemeEx = Object.assign({}, TabTheme, {
  Main: styled(TabTheme.Main).withConfig({
    displayName: "styles__Main",
    componentId: "oodkzt-2"
  })(["display:flex;flex-direction:column;align-items:center;justify-content:flex-start;width:144px;height:140px;padding:2rem 2rem 1rem 2rem;border:4px solid transparent;margin-left:0;&.active{background:none;border-radius:unset;border-bottom-color:", ";}"], black())
});
export var TabTitle = styled.h2.withConfig({
  displayName: "styles__TabTitle",
  componentId: "oodkzt-3"
})(["text-align:center;text-transform:uppercase;margin-top:2rem 0 0 0;font-size:1.6rem;font-weight:300;"]);